import { RefObject,useEffect } from 'react';
import { useRouter } from 'next/router';

export const useScrollToTop = (scrollRef?: RefObject<HTMLElement>) => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = () => {
      const el = scrollRef?.current || window;
      
      if ('scrollTo' in el) {
        el.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };

    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router, scrollRef]);

  return null;
};
